import React from "react";
import ButtonLoading from "../../Button/ButtonLoading";
import LegalbirdIoModal from "../../Modal/LegalbirdIoModal";
import ValidatorForm from "../../Validator/ValidatorForm";
import ValidatorTextField from "../../Validator/ValidatorTextField";
import useForm from "../../../hooks/useForm";
import { minStringLength, requiredFieldDefault } from "../../../services/validationRules";
import { formValue } from "../../../services/formServiceFunctions";
import { PAID_TASK_STATUS_ASSIGNED, PAID_TASK_STATUS_IN_PRE_REVIEW } from "../paidTaskStatus";
import { useMutation } from "@tanstack/react-query";
import { updateResource } from "../../../services/ReactQuery/reactQueryService";
import { useNavigate } from "react-router-dom";
import { getCaseLinkByBackofficeCase } from "../../../services/Product/ProductService/productService";
import { PaidTask } from "../../../types/PaidTask";
import dayjs from "dayjs";

type DeletePaidTaskModalProps = {
  paidTask: PaidTask;
  handleClose: Function;
  open: boolean;
  setIsLoading: Function;
  isLoading: boolean;
};
const DeletePaidTaskModal = ({ paidTask, handleClose, open, setIsLoading, isLoading }: DeletePaidTaskModalProps) => {
  const updateMutation = useMutation({
    mutationFn: updateResource
  });
  const navigate = useNavigate();

  const initialValues = {
    deletedReason: "",
  };

  const displayDeletedReason = [PAID_TASK_STATUS_ASSIGNED, PAID_TASK_STATUS_IN_PRE_REVIEW].includes(paidTask.status);

  const onSubmit = async () => {
    setIsLoading(true);
    let payload: Partial<PaidTask>= {
      deletedDate: dayjs().format("DD.MM.YYYY"),
    };

    if (displayDeletedReason) {
      payload.deletedReason = formValue(values, "deletedReason");
    }

    await updateMutation.mutateAsync({
      uri: "paid_tasks",
      id: paidTask.id,
      data: payload,
    });
    handleClose();
    navigate(getCaseLinkByBackofficeCase(paidTask.backofficeCase));
  };

  const { values, handleChange, handleSubmit, handleBlur, registerValidators, errors } = useForm({
    initialValues,
    onSubmit,
    identifier: paidTask,
  });

  return (
    <LegalbirdIoModal
      handleClose={handleClose}
      open={open}
      title={"Möchten Sie diese Aufgabe wirklich löschen?"}
      submitButton={
        <ButtonLoading variant={"contained"} onClick={handleSubmit} isLoading={isLoading}>
          Löschen
        </ButtonLoading>
      }
    >
      {displayDeletedReason && (
        <>
          Der zugeordnete Anwalt wird per E-Mail über das Löschen informiert und ihm wird der unten angegebene Grund für
          das Löschen genannt. Bitte daher kurz begründen, wieso die Aufgabe trotz Annahme gelöscht wurde.
          <ValidatorForm>
            <ValidatorTextField
              label={"Grund für Löschung"}
              name={"deletedReason"}
              onChange={handleChange}
              onBlur={handleBlur}
              value={formValue(values, "deletedReason")}
              registerValidators={registerValidators}
              error={!!errors["deletedReason"]}
              helperText={errors["deletedReason"]}
              validators={[
                ...requiredFieldDefault,
                {
                  validator: minStringLength,
                  params: [25],
                  message: "Der Text muss mindestens 25 Zeichen lang sein",
                },
              ]}
              isHighlighted={undefined}
              initialDependentValidationFields={undefined}
            />
          </ValidatorForm>
        </>
      )}
    </LegalbirdIoModal>
  );
};
export default DeletePaidTaskModal;
